import { createSelector } from '@reduxjs/toolkit'

import { selectUserLanguage } from '@/store/selectors/userSelector'
import { PUNCHOUT_IN_SHOP_BEHAVIOUR_TYPES } from '@/libs/constants/configs'

import FuturetechLogoIcon from '../../assets/img/Futuretech_Logo.svg?url'
import KaercherLogoIcon from '../../assets/img/Kaercher_Logo_2015_CO_rgb-without-borders.svg?url'

export const selectAvailableCountries = (state) => state.config.availableCountries.data ?? []
export const selectCountryName = createSelector(
  [selectAvailableCountries, (_state, countryCode = '') => countryCode],
  (availableCountries, countryCode) =>
    availableCountries.find((country) => country?.countryId === countryCode)
      ?.countryName,
)

export const selectServiceRepairPageByLanguage = createSelector(
  (state) => state.config.serviceRepairPage,
  selectUserLanguage,
  (serviceRepairPage, language) => serviceRepairPage[language],
)
export const selectIsCurrencyFront = (state) =>
  !!state.config.currencyConfig.currency_position_front

export const selectCurrencySymbol = (state) => state.config.currencyConfig.currency_symbol

export const selectEquipmentManagerLink = (state) => state.config.equipmentManagerLink

export const selectLogo = createSelector(
  (state) => state.config?.logo,
  (logo) => {
    if (logo === 'futuretech') {
      return FuturetechLogoIcon
    }
    return KaercherLogoIcon
  },
)

export const selectRegions = (state) => state.config.regionList
export const selectFormattedRegions = createSelector(
  selectRegions,
  (regions) =>
    Object.values(regions).map((region) => ({
      value: region.id,
      label: region.label,
    })),
)

export const selectDateFormat = (state) => state.config.dateFormat

export const selectIsFuturetech = createSelector(
  (state) => state.config?.logo,
  (logo) => logo === 'futuretech',
)

export const selectHideQuickEntry = (state) => state.config.hideQuickEntry

export const selectShowVAT = (state) => state.config.showVAT

export const selectIsRentalAvailable = (state) => state.config.rentalAvailable

export const selectShouldRenderServiceMenu = (state) => state.config.shouldRenderServiceMenu

export const selectShouldHideHouseNumberEntryField = (state) =>
  state.config.hideHouseNumberEntryField

export const selectAvailableSalesOrgs = (state) => state.config.availableSaleOrgs

export const selectCountryNames = (state) => state.config.countryNames

export const selectAddressScheme = (state) => state.config.addressScheme

export const selectDeactivateShoppingCart = (state) => state.config.deactivateShoppingCart

export const selectHideListPriceGlobal = (state) => state.config.hideListPriceGlobal

export const selectHideStatus = (state) => state.config.hideStatus

export const selectHideEstimatedDeliveryTime = (state) => state.config.hideEstimatedDeliveryTime

export const selectIsRequiredReference = (state) => state.config.isRequiredReference

export const selectHideVoucher = (state) => state.config.hideVoucher

export const selectPunchoutInShopBehaviour = (state) =>
  state.config.punchoutInShopBehaviour

export const selectAllowDirectShopCheckout = createSelector(
  selectPunchoutInShopBehaviour,
  (behaviour) => behaviour === PUNCHOUT_IN_SHOP_BEHAVIOUR_TYPES.DIRECT_CHECKOUT,
)
